export const getDefaultRouteByRole = (role?: string | null): string => {
  if (role === "seller") return "/orders";
  if (role === "teacher" || role === "teacher_admin")
    return "/gestion-academy/programs";
  return "/users";
};
